// extracted by mini-css-extract-plugin
export default {"ListContainer":"SpaceSettings_ListContainer__+8UrE"};